export const taskCenter = {
  syrw: "使命で始まり、あなたで終わります",
  zjlbt: "Biking USDTボーナスはノンストップで受け取れます",
  wdjj: "私のボーナス",
  rwsm: "タスクの説明",
  rwlb: 'タスクリスト',
  jljl: "報酬レコード",
  klq: "コレクションに利用可能:",
  flzm: "Biking 福祉の門",
  dcjl: "達成したらすぐに USDT 報酬を受け取り、ずっと同行してください",
  yjlq: "ワンクリックコレクション",
  lqcg: "正常に受信しました",
  wdl: "ログインしていません",
  jxz: "進行中",
  ylq: "受信しました",
  rwjd: 'タスクの進行状況',
  xsrw: '初心者のタスク',
  hyrw: '契約タスク',
  cjrz: 'ジュニア認定',
  gjrz: '高度な認証',
  scbbjy: '最初のコイン取引',
  schyjy: '最初の契約トランザクション',
  scccz: '最初の再充電',
  schyhz: '最初の契約譲渡',
  jyl: '取引高',
  ylje: '利益額',
  ksje: '損失額',
  dbkcbzj: '単一の開始マージン',
  rjl: '入金額',
  dbczje: '1 回のリチャージ額',
  rwxq: 'タスクの詳細'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/task/ja_JP.js